import { render, staticRenderFns } from "./AssignExistingLabel.vue?vue&type=template&id=11f95ae9&scoped=true"
import script from "./AssignExistingLabel.vue?vue&type=script&lang=js"
export * from "./AssignExistingLabel.vue?vue&type=script&lang=js"
import style0 from "./AssignExistingLabel.vue?vue&type=style&index=0&id=11f95ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f95ae9",
  null
  
)

export default component.exports